export const AUTHENTICATE_ADDRESS_REQUEST = 'AUTHENTICATE_ADDRESS_REQUEST';
export const AUTHENTICATE_ADDRESS_SUCCESS = 'AUTHENTICATE_ADDRESS_SUCCESS';
export const AUTHENTICATE_ADDRESS_FAILURE = 'AUTHENTICATE_ADDRESS_FAILURE';
export const CLEAR_AUTHENTICATE = 'CLEAR_AUTHENTICATE';
export const CLEAR_AUTHENTICATE_STATUS = 'CLEAR_AUTHENTICATE';

export const AUTHENTICATE_EMAIL_REQUEST = 'AUTHENTICATE_EMAIL_REQUEST';
export const AUTHENTICATE_EMAIL_SUCCESS = 'AUTHENTICATE_EMAIL_SUCCESS';
export const AUTHENTICATE_EMAIL_FAILURE = 'AUTHENTICATE_EMAIL_FAILURE';

export const ADD_EMAIL_REQUEST = 'ADD_EMAIL_REQUEST';
export const ADD_EMAIL_SUCCESS = 'ADD_EMAIL_SUCCESS';
export const ADD_EMAIL_FAILURE = 'ADD_EMAIL_FAILURE';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';

export const GET_ALLOWANCES_REQUEST = 'GET_ALLOWANCES_REQUEST';
export const GET_ALLOWANCES_SUCCESS = 'GET_ALLOWANCES_SUCCESS';
export const GET_ALLOWANCES_FAILURE = 'GET_ALLOWANCES_FAILURE';

export const REQUEST_ALLOWANCE_REQUEST = 'REQUEST_ALLOWANCE_REQUEST';
export const REQUEST_ALLOWANCE_SUCCESS = 'REQUEST_ALLOWANCE_SUCCESS';
export const REQUEST_ALLOWANCE_FAILURE = 'REQUEST_ALLOWANCE_FAILURE';

export const GET_ALLOWANCE_REQUEST = 'GET_USER_ALLOWANCE_REQUEST';
export const GET_ALLOWANCE_SUCCESS = 'GET_USER_ALLOWANCE_SUCCESS';
export const GET_ALLOWANCE_FAILURE = 'GET_USER_ALLOWANCE_FAILURE';

export const AUTHENTICATE_LEDGER_REQUEST = 'AUTHENTICATE_LEDGER_REQUEST';
export const AUTHENTICATE_LEDGER_SUCCESS = 'AUTHENTICATE_LEDGER_SUCCESS';
export const AUTHENTICATE_LEDGER_FAILURE = 'AUTHENTICATE_LEDGER_FAILURE';

export const WALLET_CHECK_SUPPORTED_REQUEST = 'WALLET_CHECK_SUPPORTED_REQUEST';
export const WALLET_CHECK_SUPPORTED_SUCCESS = 'WALLET_CHECK_SUPPORTED_SUCCESS';
export const WALLET_CHECK_SUPPORTED_FAILURE = 'WALLET_CHECK_SUPPORTED_FAILURE';

export const SILENT_AUTHENTICATE_REQUEST = 'SILENT_AUTHENTICATE_REQUEST';
export const SILENT_AUTHENTICATE_SUCCESS = 'SILENT_AUTHENTICATE_SUCCESS';
export const SILENT_AUTHENTICATE_FAILURE = 'SILENT_AUTHENTICATE_FAILURE';

export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const CLEAR_USER = 'CLEAR_USER';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';
export const CLEAR_UPDATE_USER = 'CLEAR_UPDATE_USER';

export const SET_IS_STORAGE_PROVIDER = 'SET_IS_STORAGE_PROVIDER';
